import {create} from 'zustand';
import {IFrameModalStore} from './types';

export const useIFrameModalStore = create<IFrameModalStore>(set => ({
	isIFrameOpen: false,
	setIFrameOpen: isOpen =>
		set(() => ({
			isIFrameOpen: isOpen,
		})),
}));
